/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_SavedInputs */

const en_knp_guide_saved = /** @type {(inputs: Knp_Guide_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide details saved`)
};

const fr_knp_guide_saved = /** @type {(inputs: Knp_Guide_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails du guide enregistrés`)
};

const de_knp_guide_saved = /** @type {(inputs: Knp_Guide_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitfadendetails gespeichert`)
};

const it_knp_guide_saved = /** @type {(inputs: Knp_Guide_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli della guida salvati`)
};

const ru_knp_guide_saved = /** @type {(inputs: Knp_Guide_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранены подробные сведения о руководстве.`)
};

const es_knp_guide_saved = /** @type {(inputs: Knp_Guide_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles de la guía guardados`)
};

const zh_cn2_knp_guide_saved = /** @type {(inputs: Knp_Guide_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指南详情已保存`)
};

const ja_knp_guide_saved = /** @type {(inputs: Knp_Guide_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ガイドの詳細を保存しました`)
};

const hi_knp_guide_saved = /** @type {(inputs: Knp_Guide_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गाइड का विवरण सहेज लिया गया`)
};

const pt_pt2_knp_guide_saved = /** @type {(inputs: Knp_Guide_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes do guia salvos`)
};

/**
* | output |
* | --- |
* | "Guide details saved" |
*
* @param {Knp_Guide_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_saved = /** @type {((inputs?: Knp_Guide_SavedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_SavedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_saved(inputs)
	if (locale === "de") return de_knp_guide_saved(inputs)
	if (locale === "it") return it_knp_guide_saved(inputs)
	if (locale === "ru") return ru_knp_guide_saved(inputs)
	if (locale === "es") return es_knp_guide_saved(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_saved(inputs)
	if (locale === "ja") return ja_knp_guide_saved(inputs)
	if (locale === "hi") return hi_knp_guide_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_saved(inputs)
	return en_knp_guide_saved(inputs)
});